import * as React from 'react'
import * as jotai from 'jotai'

import * as hooks from '@owl-nest/hooks'
import { Either } from '@owl-nest/monad'

import * as entity from '@boutique/entities'

import { searchGiftIdea } from './searchGiftIdea'

export type Cache = hooks.Cache<entity.search.giftIdea.Result>

export const PRODUCT_CACHE = jotai.atom<Cache>({})

type Config = {
  fetchOnMount?: boolean | 'force'
}

export function useGiftIdeaSearch(searchQuery: entity.search.giftIdea.Query, { fetchOnMount = false }: Config = {}) {
  const sharedQuery = hooks.useSharedQuery(
    async (searchQuery) => {
      try {
        const result = await searchGiftIdea(searchQuery)
        return Either.right(result)
      } catch (error) {
        return Either.left({ status: -1, url: 'algolia', body: undefined, cause: error })
      }
    },
    {
      atom: PRODUCT_CACHE,
      id,
    },
  )

  React.useEffect(() => {
    if (fetchOnMount === 'force' && getResponse().status !== hooks.QueryStatus.PENDING) {
      query()
    } else if (fetchOnMount && getResponse().status === hooks.QueryStatus.PRISTINE) {
      query()
    }
  }, [id(searchQuery)])

  return {
    query,
    response: getResponse(),
  }

  function getResponse() {
    return sharedQuery.getCurrentResponse([searchQuery])
  }

  function query() {
    return sharedQuery.query(searchQuery)
  }
}

export function id(searchQuery: entity.search.giftIdea.Query) {
  return JSON.stringify([
    searchQuery.facetFilters?.category,
    searchQuery.facetFilters?.person,
    searchQuery.facetFilters?.criterion,
    searchQuery.hitsPerPage,
    searchQuery.page,
    searchQuery.showHidden,
    searchQuery.sort,
    searchQuery.priceRange?.start,
    searchQuery.priceRange?.end,
  ])
}
